import { useState, useEffect } from 'react';
import { FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import logo from './img/logo.png';
import pic from './img/supplychain.jpg';
import './App.css';
import { FaBars, FaTimes, FaHandshake, FaChartLine, FaCoins } from "react-icons/fa";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  return (
    <div className="App">
      <header className="navbar">
        <div className="logo">
          <a href="#hero"><img src={logo} alt="Sourced Savings Logo" /></a>
        </div>
        <nav>
          <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
            <li><a href="#hero">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>

          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
      </nav>
      </header>

      <section id="hero" className="hero">
        <div className="hero-text">
          <h1>Smarter Sourcing, Bigger Savings</h1>
          <p>
            Save time and money by streamlining procurement, negotiating with suppliers,
            and securing the best value for every purchase. Efficient, strategic, and
            results-driven — making procurement simple so your business can thrive.
          </p>
          <a href="#services">
            <button className="cta-btn">Read more</button>
          </a>
        </div>
        

        <div className="hero-image">
          <a href="#supply">
            <img src={pic} alt="Supply Chain" />
          </a>
        </div>
      </section>


<section id="about" className="about">
  <h2>About Us</h2>
  <p>
    Welcome to <strong>Sourced Savings</strong>, your trusted partner in strategic procurement and sourcing. We help businesses streamline purchasing processes, optimize supplier relationships, and maximize value on every spend.
  </p>
  <p>
    With extensive experience in procurement, we specialize in identifying cost-saving opportunities, managing vendor negotiations, and ensuring timely, efficient delivery that aligns with your company’s goals. Our approach is strategic, data-driven, and results-focused.
  </p>
  <p>
    Committed to quality, efficiency, and innovation, we collaborate closely with cross-functional teams to deliver solutions that meet immediate needs and support long-term growth. Our mission is simple: to make procurement seamless, strategic, and profitable for every client we serve.
  </p>

  <h2>How It Works</h2>
  <p>
    To get started, provide the details of the material or products you wish to purchase:
  </p>
  <ul>
    <li>Material Name</li>
    <li>Material Description</li>
    <li>Specifications</li>
    <li>Quantity</li>
    <li>Unit Price</li>
    <li>Vendor Name</li>
    <li>Previous Order History</li>
    <li>Upcoming Forecast</li>
  </ul>
  <p>
    Our team will source the materials strategically to secure the best deal possible. This may include negotiating volume discounts, exploring alternative vendors, or leveraging international sourcing options.
  </p>
  <p>
    Once we identify a potential saving, we handle all the necessary arrangements, including vendor setup and payment terms if required. Our fee is structured as a percentage of the savings achieved. For example, if a single order can save a total of $10,000, our fee would be 25% which is $2,500, leaving you with a net saving of $7,500. Payment to the vendor is then arranged, ensuring a seamless and transparent process.
  </p>
</section>



      <section class="services" id="services">
  <h2>Our Services</h2>

  <div class="service-grid">
    <div class="service-card">
      <FaHandshake className="service-icon" />
      <h3>Strategic Sourcing</h3>
      <p>
        Identify cost-saving opportunities and secure competitive supplier terms through
        expert negotiation and sourcing analysis.
      </p>
    </div>

    <div class="service-card">
      <FaChartLine className="service-icon" />
      <h3>Procurement Optimization</h3>
      <p>
        Streamline your purchasing workflows using data-driven insights to
        improve efficiency and supplier performance.
      </p>
    </div>

    <div class="service-card">
      <FaCoins className="service-icon" />
      <h3>Cost Analysis & Savings</h3>
      <p>
        Evaluate spend data to uncover hidden savings and improve ROI across all sourcing
        categories.
      </p>
    </div>
  </div>
</section>

      <section id="contact" className="contact">
        <h2>Contact Us</h2>
        <form className="contact-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit" className="cta-btn">Send Message</button>
        </form>
        
      </section>

      <footer className="footer">
        <div className="social-icons">
          <a href="https://instagram.com/sourcedsavings"><FaInstagram /></a>
          <a href="https://linkedin.com/in/damon-morgan"><FaLinkedinIn /></a>
        </div>
        <p className="copyright">
          © {new Date().getFullYear()} Sourced Savings. All rights reserved.
        </p>
        <br></br>
        <p>Site developed by: <a href='https://damonmorgan.net'>Damon M</a></p>
      </footer>

      {showButton && (
        <button className="back-to-top" onClick={scrollToTop}>
          ↑
        </button>
      )}
    </div>
  );
}

export default App;
